export interface __Pagination<T> {
    num_of_pages: number;
    count: number;
    data: T[];
}

export interface __Response<T> {
    data: T;
    status: number;
}

export enum __Direction {
    rtl = 'rtl',
    ltr = 'ltr',
}

export interface __ImageFileAttachment {
    id: number | string;
    avatar: string;
}

export enum __WebViewMessages {
    backValid = 'backValid',
    backInValid = 'backInValid',
    goBack = 'goBack',
    notification = 'notification',
}

export interface __NotificationType {
    body: string;
    created_at: string;
    id: number;
    title?: string;
}
